<template>
    <div class="pageContent" style="background-color:#F0F0F0">
        <!--<mu-appbar title="微信支付">
            <mu-icon-button icon="keyboard_arrow_left" slot="left" v-on:click="goback"/>
        </mu-appbar>-->
        <pageTitle title='微信支付'></pageTitle>
        <div style="width:100%;height:2.2rem;line-height:2.2rem;text-align:center;background-color:#FFF">
            <span style="font-weight:bold;font-size:0.28rem;color:#333333;padding-right:10px;">￥</span>
            <span style="font-weight:bold;font-size:0.64rem;color:#333333">{{totalFee}}</span>
        </div>
        <mu-divider />
        <div style="width:100%;background-color:#FFF">
            <div style="width:92%;height:1.14rem;line-height:1.14rem;margin-left:auto;margin-right:auto;">
                <span style="font-size:0.28rem;color:#999999">订单号：</span>
                <span style="font-size:0.28rem;color:#333333">{{parentNo}}</span>
            </div>
        </div>
        <div style="width:92%;height:0.88rem;line-height:0.88rem;margin-left:auto;margin-right:auto;background-color:#1AAD19;margin-top:0.5rem;border-radius:0.08rem;font-size:0.32rem;color:#FFF;text-align:center" @click="wepay">
            <p v-if="allowPay">微信支付</p>
            <p v-if="!allowPay">微信支付中...</p>
        </div>
        <div style="width:92%;margin-left:auto;margin-right:auto;height:0.68rem;margin-top:0.4rem;font-size:0.24rem">
            <li style="list-style-type:disc">格林豪泰酒店集团不会记录您的任何微信信息，所有信息均由加密通道传递给微信支付</li>
        </div>
        <div style="width:92%;margin-left:auto;margin-right:auto;height:0.34rem;line-height:0.34rem;margin-top:0.4rem;font-size:0.24rem">
            <li style="list-style-type:disc">本服务由微信支付提供技术支持</li>
        </div>
        <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline" />

        <div style="position:absolute;top:0;bottom:0;left:0;right:0;background:#000;opacity:0.6;" v-if="!allowPay"></div>

    </div>
</template>

<script>
import api from '../../api'
export default {
    data() {
        return {
            totalFee: 0,
            parentNo: '',
            code: '',
            TellUser: '',
            toast: false,
            orderType: 0,
            allowPay: true
        }
    },
    mounted() {
        var parentNo = this.$route.query.state;
        var code = this.$route.query.code;
        this.code = code;
        this.parentNo = parentNo;
        this.orderType = this.$route.query.payType;
        this.totalFee = this.$route.query.totalfee;
        //this.initOrder(parentNo);
        console.log(this.orderType)
    },
    methods: {
        goback() {
            this.$router.go(-1)
        },
        initOrder(parentNo, orderType) {
            var param = new this.URLSearchParam();
            param.append('parentNo', parentNo);
            param.append('orderType', this.orderType);
            this.$http.post(api.InitOrderWePay(), param.toParam()).then((res) => {
                if (res.Result) {
                    this.totalFee = res.Data;
                } else {
                    this.TellUser = res.Message;
                    this.showToast();
                }

            });
        },
        // 弹出层
        showToast() {
            this.toast = true
            if (this.toastTimer) clearTimeout(this.toastTimer)
            this.toastTimer = setTimeout(() => { this.toast = false; this.goback(); }, 3000)
        },
        hideToast() {
            this.toast = false
            if (this.toastTimer) clearTimeout(this.toastTimer)
        },
        wepay() {
            var that = this;
            if (!that.allowPay) {
                return;
            }
            if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', that.onBridgeReady(), false);
                } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', that.onBridgeReady());
                    document.attachEvent('onWeixinJSBridgeReady', that.onBridgeReady());
                }
            } else {
                that.onBridgeReady();
            }
        },
        onBridgeReady() {
            var param = new this.URLSearchParam();
            param.append('parentNo', this.parentNo);
            param.append('code', this.code);
            param.append('type', this.orderType);
            param.append('i998', true);
            var that = this;
            that.shelter(false);
            this.$http.post(api.WepayReady(), param.toParam()).then((res) => {
                that.shelter(true);
                if (!res.Result) {
                    window.alert(res.Message);
                    return;
                }
                WeixinJSBridge.invoke('getBrandWCPayRequest', {
                    "appId": res.Data.appId,     //公众号名称，由商户传入     
                    "timeStamp": res.Data.timeStamp,         //时间戳，自1970年以来的秒数     
                    "nonceStr": res.Data.nonceStr, //随机串     
                    "package": res.Data.package,
                    "signType": "MD5",         //微信签名方式:     
                    "paySign": res.Data.paySign //微信签名 
                }, function(res) {
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                        if (that.orderType == 0) {
                            //window.location.href="https://i.998.com/home/order?t="+Math.random();
                            that.$router.push({ path: '/home/order' });
                        } else if (that.orderType == 1) {
                            //window.location.href="https://i.998.com/home/wallet?t="+Math.random();
                            that.$router.push({ path: '/wallet/valueCardDetail' });
                        } else if (that.orderType == 2) {
                            that.$router.push({ path: '/user/Breakfast' });
                        } else {
                            //window.location.href="https://i.998.com/home/index?t="+Math.random();
                            that.$router.push({ path: '/home/index' });
                        }
                    } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                        window.alert("交易取消");
                    } else {
                        window.alert("交易失败");
                    }

                    if (that.orderType == 0) {
                        that.$router.push({ path: '/home/order' });
                    } else if (that.orderType == 1) {
                        that.$router.push({ path: '/wallet/valueCardDetail' });
                    } else if (that.orderType == 2) {
                        that.$router.push({ path: '/user/Breakfast' });
                    } else {
                        that.$router.push({ path: '/home/index' });
                    }


                });

            });
        },
        shelter(show) {
            this.allowPay = show;
        }

    }
}
</script>


// WEBPACK FOOTER //
// wepay.vue?e8e97e3c